import {useState} from "react"
import {createModel} from "hox"

function ShowMask() {
    const [status, setStatus] = useState(false)

    const init = () => {
        setStatus(false)
    }

    const toTrue = () => {
        setStatus(true)
    }
    const toFalse = () => {
        setStatus(false)
    }
    return {
        value: status,
        init,
        toTrue,
        toFalse,
    }
}

export default createModel(ShowMask)
